import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import { useSelector } from 'react-redux';
import { formatAmount } from '@Utils/formatters';

export const initialAddForm = {
    employeeId: 0,
    employeeName: '',
    requestDate: moment().format('MM/DD/YYYY'),
    hireNeededDate: moment().format('MM/DD/YYYY'),
    departmentid: 0,
    purposeofRequest: '',
    hiringManager: 0,
    additional: '',
    reasonofRequest: '',
    reasonofRequestCharCount: 250,
    jobTitleID: 0,
    jobLevelID: 0,
    jobPostingStatus: '',
    projectAssignment: '',
    projectLeader: '',
    headcountNo: 0,
    basicRequirements: '',
    basicRequirementsCharCount: 250,
    skillsNeeded: '',
    skillsNeededCharCount: 250,
    specialEquipment: '',
    listofEquipment: '',
    EquipmentRequestID: 0,
    ErfID: undefined,
    EquipmentType: '',
    EquipmentArrayIDS: [],
}

const defaultState = {
    loading: false,
    addForm: { ...initialAddForm },
    holidayDates: [],
    alert: {
        show: false,
        title: 'Create success',
        content: 'Successfuly created record.',
        confirmLabel: 'Ok',
    },
    approverddl: [],
}

export default function addReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_FIELD:
        case types.CHG_STATUS:
        case types.CHG_EMPLOYEE_ID:
            return update(state, {
                addForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                addForm: { $set: { ...initialAddForm, employeeId: action.payload } },
                alert: { $set: defaultState.alert }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.UPD_ADD_MEMO_CHAR_COUNT:
            return update(state, {
                addForm: {
                    memoCharCount: { $set: state.addForm.memoCharCount - 1 }
                }
            });
        case types.INSERT_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            })
        case types.HIDE_ADD_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            })
        case types.FETCH_EMPLOYEE_SV_DDL:
            return update (state, {
                approverddl: { $set: action.payload }
            })
        case types.SET_HOLIDAY_DATES:
            return update(state, {
                holidayDates: { $set: action.payload.holidayDates }
            });
        default:
            return state;
    }
};